import React from 'react';
import { Fuel, CheckCircle } from 'lucide-react';
import { OIL_GAS } from '../data/mockData';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../components/ui/card';

const OilGas = () => {
  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header-section">
        <div className="section-container">
          <h1 className="page-title">Oil & Gas</h1>
          <p className="page-subtitle">
            Premium fuels and lubricants meeting international standards
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="products-section">
        <div className="section-container">
          <div className="products-grid">
            {OIL_GAS.map((product) => (
              <Card key={product.id} className="product-card">
                <CardHeader>
                  <div className="product-card-icon">
                    <Fuel size={28} />
                  </div>
                  <CardTitle className="product-card-title">{product.name}</CardTitle>
                  <CardDescription className="product-card-description">
                    {product.shortDesc}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="product-specs">
                    {product.standard && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Standard:</span>
                        <span className="product-spec-value">{product.standard}</span>
                      </div>
                    )}
                    {product.cetane && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Cetane Number:</span>
                        <span className="product-spec-value">{product.cetane}</span>
                      </div>
                    )}
                    {product.sulphur && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Sulphur Content:</span>
                        <span className="product-spec-value">{product.sulphur}</span>
                      </div>
                    )}
                    {product.flashPoint && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Flash Point:</span>
                        <span className="product-spec-value">{product.flashPoint}</span>
                      </div>
                    )}
                    {product.freezingPoint && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Freezing Point:</span>
                        <span className="product-spec-value">{product.freezingPoint}</span>
                      </div>
                    )}
                    {product.specification && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Specification:</span>
                        <span className="product-spec-value">{product.specification}</span>
                      </div>
                    )}
                    {product.grades && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Grades:</span>
                        <span className="product-spec-value">{product.grades}</span>
                      </div>
                    )}
                    {product.standards && (
                      <div className="product-spec-item">
                        <span className="product-spec-label">Standards:</span>
                        <span className="product-spec-value">{product.standards}</span>
                      </div>
                    )}
                  </div>
                  {product.applications && (
                    <div className="product-applications">
                      <h4 className="product-applications-title">Key Applications:</h4>
                      <ul className="product-applications-list">
                        {product.applications.slice(0, 3).map((app, index) => (
                          <li key={index} className="product-application-item">
                            <CheckCircle size={14} className="product-check-icon" />
                            {app}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="info-section">
        <div className="section-container">
          <div className="info-card">
            <h2 className="info-title">Supply & Compliance</h2>
            <p className="info-text">
              We manage bulk supply contracts with flexible FOB / CIF terms and ensure safe, 
              secure transport to your designated ports or terminals. All our fuel products 
              meet strict international quality and safety standards.
            </p>
            <div className="info-features">
              <div className="info-feature">
                <CheckCircle className="info-feature-icon" />
                <span>International quality standards</span>
              </div>
              <div className="info-feature">
                <CheckCircle className="info-feature-icon" />
                <span>Secure logistics and handling</span>
              </div>
              <div className="info-feature">
                <CheckCircle className="info-feature-icon" />
                <span>Complete documentation</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OilGas;
